import hosts from "constants/hosts"
import { routes } from "router/routes"

const getEnvironmentNameFromHost = (host) => {
  if (host?.includes("localhost")) return "local"
  if (host?.includes("manage")) return "prod"
  return host?.split(".")[0]
}

const getHostsByEnvironment = () => {
  const envHost = process.env.REACT_APP_PRO_HOST

  if (!envHost) {
    // Environment variable not configured
    return null
  }

  const environmentName = getEnvironmentNameFromHost(envHost)
  const environment = hosts[environmentName]

  if (!environment) {
    // No matching environment configuration found
    return null
  }

  return environment
}

/**
 * Generate full URL for a given path
 * @param {string} path - The route path to generate URL for
 * @returns {string} Full URL with protocol, host, and path
 */
const generateFullUrl = (path) => {
  const environment = getHostsByEnvironment()
  if (!environment) {
    // Failed to get environment configuration
    return ""
  }

  const { PROTOCOL, CUSTOMER } = environment
  return `${PROTOCOL}${CUSTOMER}/#${path}`
}

/**
 * Generate guide profile URL
 * @param {string} slug - Guide profile slug
 * @returns {string} Full guide profile URL
 */
const generateGuideProfileUrl = (slug) => {
  const path = routes.proGuideProfilePath({ slug })
  return generateFullUrl(path)
}

/**
 * Copy text to clipboard
 * @param {string} text - Text to copy
 * @returns {Promise<void>}
 */
const copyToClipboard = async (text) => {
  await navigator.clipboard.writeText(text)
}

export { getHostsByEnvironment, generateFullUrl, generateGuideProfileUrl, copyToClipboard }
